import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Gallery from '../views/Gallery.vue'
import Home202312 from '../views/Home202312.vue'
import Gallery202312 from '../views/Gallery202312.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: Gallery
  },
  {
    path: '/202312',
    name: 'Home202312',
    component: Home202312
  },
  {
    path: '/202312/gallery',
    name: 'Gallery202312',
    component: Gallery202312
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
